import { Fragment } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { getClassName } from '../helpers';
import { Item } from '../templates';

export const List = () => {
  const { files } = useSettings();

  return (
    <Component>
      {files.map((item) => (
        <Fragment key={item.id}>
          <Item item={item} />
        </Fragment>
      ))}
    </Component>
  );
};

const Component = styled.div.attrs({
  className: getClassName('list', 'component')
})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-basis: auto;
`;
